import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';

export type AdvancedUser = {
  netId: string;
  givenName: string;
  surname: string;
  title: string;
  department: string;
  email: string;
};

type UseAdvancedUserSearchResult = {
  data: { advancedUser: AdvancedUser } | undefined;
  error: Error | undefined;
  loading: boolean;
};

// Define the GraphQL query to search for a user by netId
const ADVANCED_USER_SEARCH = gql`
  query AdvancedUser($netId: String!) {
    advancedUser(netId: $netId) {
      netId
      givenName
      surname
      title
      department
      email
    }
  }
`;

// Custom hook to search for a user by netId
export const useAdvancedUserSearch = (
  netId?: string,
  skip: boolean = true, // Default to skipping the query
): UseAdvancedUserSearchResult => {
  const { data, error, loading } = useQuery(ADVANCED_USER_SEARCH, {
    variables: { netId },
    skip, // Skip the query if netId is not provided or skip is true
    fetchPolicy: 'network-only',
  });

  return {
    data,
    error,
    loading,
  };
};
